module.exports = __webpack_public_path__ + "static/media/resisitirparaexistir_2.19dff9af.jpg";